import { motion } from 'motion/react';
import { Sparkles } from 'lucide-react';
import type { ReactNode } from 'react';
import {
  insightHeadingClassName,
  insightSubheroClassName,
} from './InsightPointer';

interface InsightSummaryProps {
  ariaLabel: string;
  heading: ReactNode;
  subhero?: ReactNode;
}

const springPop = { type: 'spring' as const, stiffness: 500, damping: 22 };

export default function InsightSummary({ ariaLabel, heading, subhero }: InsightSummaryProps) {
  const hasSubhero = Boolean(subhero);

  return (
    <div className="flex w-full flex-col justify-center" aria-label={ariaLabel}>
      <div className={`flex w-full gap-3 ${hasSubhero ? 'items-start' : 'items-center'}`}>
        <motion.span
          initial={{ scale: 0.6, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={springPop}
          className={`${hasSubhero ? 'mt-0.5 ' : ''}flex h-8 w-8 sm:h-10 sm:w-10 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br from-emerald-500 to-teal-600 text-white shadow-sm shadow-emerald-500/15`}
        >
          <Sparkles className="h-4 w-4" aria-hidden="true" />
        </motion.span>
        <div className={`min-w-0 flex-1 ${hasSubhero ? 'pt-0.5' : ''}`}>
          <p className={insightHeadingClassName}>{heading}</p>
          {hasSubhero ? <p className={insightSubheroClassName}>{subhero}</p> : null}
        </div>
      </div>
    </div>
  );
}
